import * as React from 'react';
import { Paper, Box, CircularProgress } from '@mui/material';

export default function LoadingBackgroundProcess({ loading = false }) {
  return (
    <Box sx={{
      position: 'fixed',
      bottom: 0,
      right: 0,
      zIndex: 1000,
      display: loading ? 'block' : 'none',
    }}>
      <Paper sx={{
        variant: 'outlined',
        bgcolor: 'action.disabledBackground',
        p: 1,
        m: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <CircularProgress />

      </Paper>

    </Box >
  );
}